function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback } from "react";
import { BottomSheet } from "sprout-ui-dom/dist/BottomSheet";
import { useSnackbar } from "sprout-ui-dom/dist/Snackbar";
import { useNavigationListListContext } from "@sprout/list-navigation";
import { scrollPostIntoView } from "@sprout/client-components/dist/Post";
import useTopicPageCreateDivider from "../graphql/mutations/useTopicPageCreateDivider";
import useUpdateDivider from "../graphql/mutations/useUpdateDivider";
import TopicPageEditorDividerDesktop from "./TopicPageEditorDividerDesktop";
import TopicPageEditorDividerMobile from "./TopicPageEditorDividerMobile";
const TopicPageEditorDivider = (props)=>{
    const { open , closeEditor , title , color , dividerId , dividerNodeId , topicId , topicNodeId , context , afterItemId ,  } = props;
    const showSnackbar = useSnackbar();
    const createDivider = useTopicPageCreateDivider();
    const updateDivider = useUpdateDivider();
    const { setActiveItemId  } = useNavigationListListContext();
    const handleCreate = useCallback(({ title: nextTitle , color: nextColor  })=>{
        if (nextTitle.length === 0) {
            closeEditor();
            return;
        }
        if (dividerId && dividerNodeId) updateDivider({
            dividerId,
            dividerNodeId,
            display: {
                color: nextColor
            },
            title: nextTitle
        }).catch(()=>{
            showSnackbar.error();
        });
        else if (topicId) createDivider(_objectSpread({}, context === "page" && !topicNodeId ? {
            context: context,
            topicNodeId: undefined
        } : {
            context: context,
            topicNodeId: topicNodeId
        }, {
            variables: {
                parentTopicId: topicId,
                afterItemId,
                display: {
                    color: nextColor
                },
                title: nextTitle
            }
        })).then((result)=>{
            var ref, ref1;
            const divider = result === null || result === void 0 ? void 0 : (ref = result.data) === null || ref === void 0 ? void 0 : (ref1 = ref.createItem) === null || ref1 === void 0 ? void 0 : ref1.item;
            if (divider) {
                scrollPostIntoView(divider);
                setActiveItemId(String(divider.id));
            }
        }).catch(()=>{
            showSnackbar.error();
        });
        closeEditor();
    }, [
        afterItemId,
        closeEditor,
        context,
        createDivider,
        dividerId,
        dividerNodeId,
        setActiveItemId,
        showSnackbar,
        topicId,
        topicNodeId,
        updateDivider, 
    ]);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(BottomSheet, {
                    open: open === "mobile",
                    unmountOnExit: true,
                    children: /*#__PURE__*/ _jsx(TopicPageEditorDividerMobile, {
                        title: title,
                        color: color,
                        closeEditor: closeEditor,
                        onCreate: handleCreate
                    })
                }),
                open === "desktop" && /*#__PURE__*/ _jsx(TopicPageEditorDividerDesktop, {
                    title: title,
                    color: color,
                    closeEditor: closeEditor,
                    onCreate: handleCreate
                })
            ]
        })
    });
};
export default TopicPageEditorDivider;
